import { ButtonTheme } from '@/components/Button'
import { LEADERBOARD_PATH, SHOP_PATH } from './hooks/routing'

type PrimaryButtonConfig = {
  href: string
  label: string
  theme: ButtonTheme
}

export const getPrimaryButton = (
  isActiveSeason: boolean
): PrimaryButtonConfig => {
  return isActiveSeason
    ? {
        href: LEADERBOARD_PATH,
        label: 'View LeaderBoard',
        theme: 'green-arcade'
      }
    : {
        href: SHOP_PATH,
        label: 'Shop Prizes',
        theme: 'white'
      }
}
